import { Component, Inject, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { SapSubmittalResponse } from '../../../../../models/dtos/Classes/SapSubmittalResponse';
import { ISapSubmittalResultDialogData } from '../../../../../models/common/ISapSubmittalResultDialogData';

@Component({
  selector: 'app-sap-submittal-result-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    TranslatePipe,
    MatIcon,
    MatButtonModule
  ],
  templateUrl: './sap-submittal-result-dialog.component.html',
  styleUrl: './sap-submittal-result-dialog.component.scss'
})
export class SapSubmittalResultDialogComponent {

  isSuccess: boolean;
  response: SapSubmittalResponse | null;

  /** Whether document upload results should be shown (only on success when docs were uploaded) */
  showDocUploadResults: boolean;
  /** Whether XML download section should be shown (for sales office 998/999) */
  showXmlDownload: boolean;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) data: ISapSubmittalResultDialogData) {
    this.isSuccess = data?.isSuccess ?? false;
    this.response = data?.response ?? null;

    // Show doc upload results only on successful submittal when opportunity existed
    // (the backend only uploads docs when the estimate has a linked opportunity)
    this.showDocUploadResults = this.isSuccess && this.response != null &&
      (this.response.isCostReviewDocUploadSuccessfull !== undefined ||
       this.response.isSapSubmittalDocUploadSuccessfull !== undefined);

    // Show XML download when XML content is returned (sales office 998/999)
    this.showXmlDownload = this.isSuccess && !!this.response?.sapSubmittalXml;
  }

  /**
   * Downloads the SAP submittal XML as a file.
   * This is only available for special sales offices (998/999) where XML is returned directly.
   */
  downloadXml(): void {
    if (!this.response?.sapSubmittalXml) return;
    const blob = new Blob([this.response.sapSubmittalXml], { type: 'application/xml' });
    const blobGIL = new Blob([this.response.gilXml], { type: 'application/xml' });
    const url = globalThis.URL.createObjectURL(blob);
    const urlGIL = globalThis.URL.createObjectURL(blobGIL);
    const link = document.createElement('a');
    link.href = url;
    link.download = this.response.sapSubmittalXmlFileName || 'sap-submittal.xml';
    link.click();
    globalThis.URL.revokeObjectURL(url);

    const linkGIL = document.createElement('a');
    linkGIL.href = urlGIL;
    linkGIL.download = this.response.gilXmlFileName || 'gil.xml';
    linkGIL.click();
    globalThis.URL.revokeObjectURL(urlGIL);
  }

}
